import { Input } from "./ui/input";
import { PatternFormat } from 'react-number-format';


export function InputData({ formik, id, label, disabled }) {
  return (
    <div className="flex flex-col gap-2 bg-white border border-border rounded-sm p-4">
      <p className="text-sm font-semibold">{label}</p>
      <PatternFormat
        disabled={disabled}
        required
        id={id}
        name={id}
        format='##/##/####'
        type="tel"
        customInput={Input}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values[id]}
      />
      {formik.touched[id] && formik.errors[id] && <span className="text-sm text-customDanger">{formik.errors[id]}</span>}
    </div>
  )
}